import { headerMenu } from "./modules/header";

document.addEventListener( 'DOMContentLoaded', function() {
    headerMenu();
  }
);


